import { Breadcrumb } from '../../types';

export const reportBreadcrumbs: Map<string, Breadcrumb> = new Map([
	[
		'eventReports',
		{
			name: 'Event Reports',
			to: '/reports/event',
			i18nKey: 'breadcrumb.eventReports',
		},
	],
]);
